/* eslint-disable import/first */
import App from '../../../app/browser/App';
import React from 'react';
import { IndexRoute, Route } from 'react-router';
import { OfficeNotFoundView } from 'angieslist-app-platform/lib/browser';
import DealsView from './DealsView';
import ReviewsView from './ReviewsView';
import ImageManagementView from './ImageManagementView';
import ServiceAreaView from './ServiceAreaView';
import AddressManagementView from './AddressManagementView';

export default function createRoutes() {
  return (
    <div>
      <Route component={App} path="/app/store">
        <IndexRoute component={OfficeNotFoundView} />
        <Route path=":serviceProviderId">
          <IndexRoute component={OfficeNotFoundView} />
          <Route path="images" component={ImageManagementView} />
          <Route path="service-areas" component={ServiceAreaView} />
          <Route path="shop" component={DealsView} />
          <Route path="reviews" component={ReviewsView} />
          <Route path="addresses" component={AddressManagementView} />
        </Route>
        <Route component={OfficeNotFoundView} path="*" />
      </Route>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/modules/store/browser/createRoutes.js